export { default } from "./useStableRef";
